import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card';
import { Calculator, Clock, FileCheck } from 'lucide-react';
import { FeeCalculator, TimelineEstimator, DocumentChecker } from './GovtToolWidgets';

export const GovtToolsTab = ({ services, onCalculateFee, onGetTimeline, onGetDocuments }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Calculator className="w-5 h-5" />
            Fee Calculator
          </CardTitle>
          <CardDescription>Calculate government fees for any service</CardDescription>
        </CardHeader>
        <CardContent>
          <FeeCalculator services={services} onCalculate={onCalculateFee} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Clock className="w-5 h-5" />
            Timeline Estimator
          </CardTitle>
          <CardDescription>Get estimated processing timeline</CardDescription>
        </CardHeader>
        <CardContent>
          <TimelineEstimator services={services} onEstimate={onGetTimeline} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileCheck className="w-5 h-5" />
            Document Checklist
          </CardTitle>
          <CardDescription>View required documents per service</CardDescription>
        </CardHeader>
        <CardContent>
          <DocumentChecker services={services} onCheck={onGetDocuments} />
        </CardContent>
      </Card>
    </div>
  );
};
